import request from '@/utils/request'

// 获取招标信息和政府采购列表
export const getList = (Method,data) => {
    return request.post(`webmanage/WebInfor/InforApp_Data.ashx?Method=${Method}`, data)
}

// 获取栏目列表
export const getInforList = (data) => {
    return request.post('webmanage/WebInfor/InforApp_Data.ashx?Method=getInforList', data)
}

// 获取详情
export const getInforDetail = (data) => {
    return request.post('webmanage/WebInfor/InforApp_Data.ashx?Method=getInforDetail', data)
}

// 获取招标公告列表数据
export const getZhaoBiaoGongGaoList = (data) => {
    return request.post('webmanage/WebInfor/InforApp_Data.ashx?Method=getZhaoBiaoGongGaoList', data)
}

// 获取资格预审公告列表数据
export const getZiGeYuShenList = (data) => {
    return request.post('webmanage/WebInfor/InforApp_Data.ashx?Method=getZiGeYuShenList', data)
}

// 获取中标候选人公示列表数据
export const getHouXuanRenGongShiList = (data) => {
    return request.post('webmanage/WebInfor/InforApp_Data.ashx?Method=getHouXuanRenGongShiList', data)
}

// 获取中标结果公示列表数据
export const getZhongBiaoResultGongShiList = (data) => {
    return request.post('webmanage/WebInfor/InforApp_Data.ashx?Method=getZhongBiaoResultGongShiList', data)
}

// 获取更正公告列表数据
export const getGengZhengGongGaoList = (data) => {
    return request.post('webmanage/WebInfor/InforApp_Data.ashx?Method=getGengZhengGongGaoList', data)
}


